import Vue from 'vue';
import VueRouter from 'vue-router';
import { routers } from '@/config/router.config';
import { isLogin } from '@/utils/cookie';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'hash',
  base: '/',
  routes: routers,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});

router.beforeEach((to, from, next) => {
  // if (to.name !== 'admin.login' && !isLogin()) {
  //   return next({ name: 'admin.login' });
  // }
  return next();
});

router.afterEach((to, from, next) => {
  document.querySelector('title').innerText = `GEEKCHIC - Hàng Hiệu Sale 07: ${to.meta.title} ${to.params.name ? to.params.name : ''}`;
});

export default router;
